<template>
  <v-sparkline
      :value="chart_value"
      :gradient="gradient"
      :smooth="radius || false"
      :padding="padding"
      :line-width="lineWidth"
      :stroke-linecap="lineCap"
      :gradient-direction="gradientDirection"
      :fill="fill"
      :type="type"
      :auto-line-width="autoLineWidth"
      auto-draw
      :show-labels="showLabels"
      :label-size="labelSize"
  ></v-sparkline>
</template>

<script>
export default {
  name: "CostTableSummaryChart",
  components: {},
  props: {
    id: {},
    chart_value: {
      default: () => [0, 2, 5, 9, 5, 10, 3, 5, -4, -10, 1]
      ,
    },
    showLabels: {
      default: () => false
      ,
    },

  },

  data() {
    return {
      lineWidth: 4,
      labelSize: 7,
      radius: 8,
      padding: 3,
      lineCap: 'round',
      gradient: ['#F1416C', '#FFC700', '#43CED7'],
      value: [0, 2, 5, 9, 5, 10, 3, 5, -4, -10, 1, 8, 2, 9, 0],
      gradientDirection: 'bottom',
      fill: true,
      type: 'trend',
      autoLineWidth: false,
    };
  },
  computed: {
    headers() {
      return [];
    },
  },
  updated() {
  },
  methods: {}

}
</script>

<style scoped lang="scss"></style>

